import React, { PureComponent, useState } from 'react'
import { DropdownButton, Form } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { fetchUsersTx } from '../../actions'
import { resetCSVExport } from '../../actions/csv_export'
import { disableStatusFilter, enableStatusFilter } from '../../actions/status_filter'
import {
  TX_STATUS_COMPLETED,
  TX_STATUS_FAILED,
  TX_STATUS_HOLD,
  TX_STATUS_NEW,
  TX_STATUS_POST_PROCESSING,
  TX_STATUS_RESTARTED,
} from '../../config'
import { transactionStateLabel } from '../../utils/display_names'

const StatusFilterRedux = (props) => {
  const defaultFilter = 'Status: No Filter'
  const allFilters = [
    TX_STATUS_NEW,
    TX_STATUS_COMPLETED,
    TX_STATUS_FAILED,
    TX_STATUS_HOLD,
    TX_STATUS_RESTARTED,
    TX_STATUS_POST_PROCESSING,
  ].sort()

  const [dropdownIsOpen, setDropdownIsOpen] = useState(false)

  const toggleDropdown = () => setDropdownIsOpen(!dropdownIsOpen)

  const handleSelectFilter = (e) => {
    const { enableStatusFilter } = props
    e.preventDefault()
    const status = e.target.value
    let { statusFilter } = props
    if (!statusFilter) {
      statusFilter = []
    }

    if (statusFilter.includes(status)) {
      enableStatusFilter(statusFilter.filter((f) => f !== status))
    } else {
      enableStatusFilter([...statusFilter, status])
    }
  }

  const resetFilters = () => {
    // todo: move to parent?
    const { disableStatusFilter, fetchUsersTx, navigateToPage, searchTerm } = props

    resetCSVExport()
    disableStatusFilter()
    fetchUsersTx(1, [], searchTerm)
    navigateToPage(1)
  }

  const getTitle = () => {
    let { statusFilter } = props
    if (!statusFilter) {
      return defaultFilter
    }
    if (statusFilter.length === 0) {
      return defaultFilter
    }
    return `Status: ${statusFilter.length} ${statusFilter.length > 1 ? 'filters' : 'filter'}`
  }

  const filter = props.statusFilter ? props.statusFilter : []

  return (
    <DropdownButton
      variant='default'
      id='filterDropdown'
      title={getTitle()}
      open={dropdownIsOpen}
      onToggle={toggleDropdown}
    >
      <div className={'m-1'}>
        <Form>
          {allFilters.map((status) => (
            <Form.Group style={{ padding: '0 5px' }} key={status + filter.includes(status)} controlId={status}>
              <Form.Check
                type='checkbox'
                value={status}
                checked={filter.includes(status)}
                onChange={handleSelectFilter}
                label={transactionStateLabel(status).toUpperCase()}
              />
            </Form.Group>
          ))}
        </Form>
        <span className='input-group-btn' style={{ padding: '0 5px' }}>
          <button
            name='search-filter-btn'
            className='btn btn-default'
            type='button'
            onClick={(event) => {
              toggleDropdown()
              props.updateFilter(event)
            }}
          >
            Search
          </button>
          <button name='reset-filter-btn' className='btn btn-default' type='button' onClick={resetFilters}>
            Reset
          </button>
        </span>
      </div>
    </DropdownButton>
  )
}

const mapStateToProps = (state) => ({
  searchTerm: state.transactionSearch.searchTerm,
  businessFilter: state.businessFilter.businessFilter,
  statusFilter: state.statusFilter.statusFilter,
  countryFilter: state.countryFilter.countryFilter,
  sortField: state.txGridSort.sortField,
  sortOrder: state.txGridSort.order,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      enableStatusFilter,
      disableStatusFilter,
      fetchUsersTx,
      resetCSVExport,
      navigateToPage: (p) => ownProps.history.push('#/page/' + p),
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StatusFilterRedux))
